// PreviewTemplate.tsx
import React from "react"

// Define the props interface for PreviewTemplate
interface PreviewTemplateProps {
  /** The output string of the template to be previewed */
  templateOutput: string
}

/**
 * PreviewTemplate component renders the output of a template in a styled container.
 *
 * @param props - The component props
 * @returns The rendered PreviewTemplate component
 */
const PreviewTemplate: React.FC<PreviewTemplateProps> = ({
  templateOutput,
}) => {
  return (
    <div className="flex flex-col">
      <div className="whitespace-pre-wrap">{templateOutput}</div>
    </div>
  )
}

export default PreviewTemplate
